import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { SubscriptionListPage } from '@/features/subscriptions'

export const Route = createFileRoute('/_authenticated/subscriptions/')({
  component: () => (
    <RequirePermission permission='subscriptions.read'>
      <SubscriptionListPage />
    </RequirePermission>
  ),
})
